// extracted by mini-css-extract-plugin
export default {"Tile":"CaseStudyTile_Tile__7Ts0D","Image":"CaseStudyTile_Image__b5z+w"};